var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategyOperations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.25C48.9746 56.25 56.25 48.9746 56.25 40C56.25 31.0254 48.9746 23.75 40 23.75C31.0254 23.75 23.75 31.0254 23.75 40C23.75 48.9746 31.0254 56.25 40 56.25Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.925 57.5H78.75V55H74.9362C74.6387 51.4175 73.0837 48.19 70.705 45.7625C71.06 43.865 71.25 41.93 71.25 40C71.25 22.7687 57.2313 8.75 40 8.75C38.5525 8.75 37.0788 8.8825 35.6075 9.09125L29.7225 3.20625L27.3875 5.54125C26.6213 5.15 25.8225 4.81875 25 4.55375V1.25H15V4.55375C14.1775 4.81875 13.3787 5.15 12.6125 5.54125L10.2775 3.20625L3.20625 10.2775L5.54125 12.6125C5.14875 13.3787 4.81875 14.1775 4.55375 15H1.25V25H4.55375C4.82 25.8225 5.15 26.6213 5.5425 27.3875L3.2075 29.7225L9.0925 35.6075C8.8825 37.0812 8.75 38.555 8.75 40C8.75 57.2313 22.7687 71.25 40 71.25C43.8825 71.25 47.6587 70.5413 51.25 69.1512V71.25H48.75V73.75H51.25V78.75H68.75V73.75H71.25V71.25H68.75V68.425C72.335 65.8475 74.5625 61.865 74.925 57.5ZM8.165 26.9725C7.515 25.8725 7.02375 24.6838 6.7025 23.4375L6.46 22.5H3.75V17.5H6.46L6.7025 16.5625C7.02375 15.3162 7.515 14.1275 8.165 13.0275L8.6575 12.1938L6.7425 10.2775L10.2775 6.74125L12.1938 8.6575L13.0288 8.16375C14.1275 7.515 15.3162 7.0225 16.5625 6.70125L17.5 6.46V3.75H22.5V6.46L23.4375 6.70125C24.6838 7.0225 25.8725 7.515 26.9712 8.16375L27.8063 8.6575L29.7225 6.74125L33.2575 10.2775L31.3425 12.1938L31.835 13.0275C32.485 14.1275 32.9762 15.3162 33.2975 16.5625L33.54 17.5H36.25V22.5H33.54L33.2975 23.4375C32.9762 24.6838 32.485 25.8725 31.835 26.9725L31.3425 27.8063L33.2575 29.7225L29.7225 33.2588L27.8063 31.3425L26.9712 31.8363C25.8725 32.485 24.6838 32.9775 23.4375 33.2988L22.5 33.54V36.25H17.5V33.54L16.5625 33.2988C15.3162 32.9775 14.1275 32.485 13.0288 31.8363L12.1938 31.3425L10.2775 33.2588L6.7425 29.7225L8.6575 27.8063L8.165 26.9725ZM11.25 40C11.25 38.5013 11.3875 36.9688 11.6325 35.4388L12.6125 34.4587C13.3787 34.85 14.1775 35.1813 15 35.4463V38.75H25V35.4463C25.8225 35.1813 26.6213 34.85 27.3875 34.4587L29.7225 36.7938L36.7925 29.7225L34.4575 27.3875C34.85 26.6213 35.18 25.8225 35.4463 25H38.75V15H35.4463C35.18 14.1775 34.85 13.3787 34.4575 12.6125L35.4375 11.6325C36.9663 11.3875 38.4987 11.25 40 11.25C55.8537 11.25 68.75 24.1475 68.75 40C68.75 41.2988 68.6525 42.5988 68.4775 43.8875C66.0638 42.2275 63.145 41.25 60 41.25C52.15 41.25 45.7025 47.3138 45.0637 55H41.25V57.5H45.075C45.38 61.1675 47.005 64.5562 49.6462 67.0762C46.555 68.1813 43.32 68.75 40 68.75C24.1462 68.75 11.25 55.8525 11.25 40ZM66.25 76.25H53.75V73.75H66.25V76.25ZM60 58.75C58.6213 58.75 57.5 57.6287 57.5 56.25C57.5 54.8713 58.6213 53.75 60 53.75C61.3787 53.75 62.5 54.8713 62.5 56.25C62.5 57.6287 61.3787 58.75 60 58.75ZM61.25 71.25V61.0725C63.4012 60.5138 65 58.5725 65 56.25C65 53.4925 62.7575 51.25 60 51.25C57.2425 51.25 55 53.4925 55 56.25C55 58.5725 56.5988 60.5138 58.75 61.0725V71.25H53.75V67.0888L53.1838 66.7188C49.6238 64.3963 47.5 60.4825 47.5 56.25C47.5 49.3575 53.1075 43.75 60 43.75C66.8925 43.75 72.5 49.3575 72.5 56.25C72.5 60.4825 70.3763 64.3963 66.8162 66.7188L66.25 67.0888V71.25H61.25Z",
    fill: "url(#paint0_linear_180_6671)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 46.25H58.75V48.75H61.25V46.25Z",
    fill: "url(#paint1_linear_180_6671)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8161 48.294L52.0488 50.0625L53.8173 51.8298L55.5846 50.0612L53.8161 48.294Z",
    fill: "url(#paint2_linear_180_6671)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 55H50V57.5H52.5V55Z",
    fill: "url(#paint3_linear_180_6671)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8176 60.6698L52.0491 62.437L53.8163 64.2055L55.5848 62.4383L53.8176 60.6698Z",
    fill: "url(#paint4_linear_180_6671)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1908 60.6685L64.4236 62.437L66.1921 64.2043L67.9593 62.4358L66.1908 60.6685Z",
    fill: "url(#paint5_linear_180_6671)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55H67.5V57.5H70V55Z",
    fill: "url(#paint6_linear_180_6671)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1918 48.2952L64.4233 50.0625L66.1906 51.831L67.9591 50.0638L66.1918 48.2952Z",
    fill: "url(#paint7_linear_180_6671)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C25.5138 30 30 25.5138 30 20C30 14.4863 25.5138 10 20 10C14.4863 10 10 14.4863 10 20C10 25.5138 14.4863 30 20 30ZM12.6125 18.75C12.805 17.6137 13.25 16.5638 13.8925 15.6613L15.58 17.3475L17.3475 15.58L15.66 13.8937C16.5637 13.25 17.6137 12.805 18.75 12.6125V15H21.25V12.6125C22.3862 12.805 23.4363 13.25 24.3388 13.8937L22.6513 15.58L24.4187 17.3475L26.1063 15.6613C26.75 16.5638 27.195 17.6137 27.3875 18.75H25V21.25H27.3875C27.195 22.3862 26.75 23.4363 26.1075 24.3388L24.42 22.6525L22.6525 24.42L24.34 26.1063C23.4362 26.75 22.3862 27.195 21.25 27.3875V25H18.75V27.3875C17.6137 27.195 16.5638 26.75 15.6613 26.1063L17.3487 24.42L15.5813 22.6525L13.8937 24.3388C13.25 23.4363 12.805 22.3862 12.6125 21.25H15V18.75H12.6125Z",
    fill: "url(#paint8_linear_180_6671)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1926 35.58L52.8951 33.8138L52.1039 36.185L60.5551 39.0013L64.8214 31.8913L62.6776 30.605L60.4451 34.3263C58.0651 25.725 50.4589 19.38 41.3264 18.8125L41.1726 21.3075C49.4364 21.8225 56.2851 27.6963 58.1926 35.58Z",
    fill: "url(#paint9_linear_180_6671)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9525 44.874L26.9412 47.369L28.06 45.1327L19.525 40.8652L15.1787 48.1077L17.3225 49.394L19.5725 45.644C21.9412 54.2627 29.5437 60.6227 38.6737 61.1877L38.8275 58.6927C30.7375 58.1902 24.0075 52.5302 21.9525 44.874Z",
    fill: "url(#paint10_linear_180_6671)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6671",
    x1: 1.25038,
    y1: 40.0006,
    x2: 78.75,
    y2: 40.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6671",
    x1: 58.75,
    y1: 47.5,
    x2: 61.25,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6671",
    x1: 52.9331,
    y1: 50.9461,
    x2: 54.7003,
    y2: 49.1776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6671",
    x1: 50,
    y1: 56.25,
    x2: 52.5,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_6671",
    x1: 52.9327,
    y1: 63.3213,
    x2: 54.7012,
    y2: 61.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_6671",
    x1: 65.3079,
    y1: 63.3206,
    x2: 67.0751,
    y2: 61.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_6671",
    x1: 67.5,
    y1: 56.25,
    x2: 70,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_6671",
    x1: 65.307,
    y1: 50.9468,
    x2: 67.0755,
    y2: 49.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_180_6671",
    x1: 10.0001,
    y1: 20.0002,
    x2: 30,
    y2: 20.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_180_6671",
    x1: 41.1727,
    y1: 28.907,
    x2: 64.8214,
    y2: 28.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_180_6671",
    x1: 15.1788,
    y1: 51.0266,
    x2: 38.8275,
    y2: 51.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyOperations);
export default __webpack_public_path__ + "static/media/strategy-operations.c63c3ddf904179bac4bd88d50b89805d.svg";
export { ForwardRef as ReactComponent };